import React from 'react'

const SectionTabButtons = ({ sectionTab, setSectionTab }) => {
    return (
        <div>
            <div className="d-flex justify-content-around mt-3">
                <div 
                    className='w-100 ms-3'
                    style={{
                        cursor: 'pointer',
                        borderBottom: sectionTab === 'LessonInfo' ? '2px solid #FFCC19' : 'none',
                        height: '35px',
                    }}
                    onClick={() => setSectionTab('LessonInfo')}
                >
                    <p className='text-center'>Lesson Info</p>
                </div>
                <div className='w-100 me-3'
                    style={{
                        cursor: 'pointer',
                        borderBottom: sectionTab === 'CourseOverview' ? '2px solid #FFCC19' : 'none',
                        height: '35px',
                    }}
                    onClick={() => setSectionTab('CourseOverview')}
                >
                    <p className='text-center'>Course Overview</p>
                </div>
            </div>
        </div>
    )
}

export default SectionTabButtons